import { useCallback, useState } from 'react'

/**
 * Tracks which coach cards have expanded "More Info" panels.
 */
export function useExpandedCoaches() {
  const [expandedCoaches, setExpandedCoaches] = useState(() => new Set())

  const toggleCoachExpanded = useCallback((coachId) => {
    setExpandedCoaches((prev) => {
      const next = new Set(prev)
      if (next.has(coachId)) {
        next.delete(coachId)
      } else {
        next.add(coachId)
      }
      return next
    })
  }, [])

  const isCoachExpanded = useCallback(
    (coachId) => expandedCoaches.has(coachId),
    [expandedCoaches],
  )

  return { expandedCoaches, toggleCoachExpanded, isCoachExpanded }
}
